import script from "./KiwishModal.vue?vue&type=script&setup=true&lang=js"
export * from "./KiwishModal.vue?vue&type=script&setup=true&lang=js"

import "./KiwishModal.vue?vue&type=style&index=0&id=2610b4a3&scoped=true&lang=css"
import "./KiwishModal.vue?vue&type=style&index=1&id=2610b4a3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2610b4a3"]])

export default __exports__